/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDirectoryPeopleSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListDirectoryPeopleRequest = {
  /**
   * Maximum number of people to return.
   */
  limit?: number | undefined;
  /**
   * Cursor for the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDirectoryPeopleSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryPeopleSecurity$outboundSchema: z.ZodMiniType<
  ListDirectoryPeopleSecurity$Outbound,
  ListDirectoryPeopleSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDirectoryPeopleSecurityToJSON(
  listDirectoryPeopleSecurity: ListDirectoryPeopleSecurity,
): string {
  return JSON.stringify(
    ListDirectoryPeopleSecurity$outboundSchema.parse(
      listDirectoryPeopleSecurity,
    ),
  );
}

/** @internal */
export type ListDirectoryPeopleRequest$Outbound = {
  limit: number;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryPeopleRequest$outboundSchema: z.ZodMiniType<
  ListDirectoryPeopleRequest$Outbound,
  ListDirectoryPeopleRequest
> = z.pipe(
  z.object({
    limit: z._default(z.int(), 500),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listDirectoryPeopleRequestToJSON(
  listDirectoryPeopleRequest: ListDirectoryPeopleRequest,
): string {
  return JSON.stringify(
    ListDirectoryPeopleRequest$outboundSchema.parse(listDirectoryPeopleRequest),
  );
}
